import { CHECK_EMAIL_AVAILABLE, CHECK_EMAIL_AVAILABLE_ERROR } from '../actions/index';
import { createReducer } from '../common/utils/ApiUtils';

const initialState = {
    emailCheckSuccessful: false,
    emailAvailableResponse: null
};

export default createReducer(initialState, {
    [CHECK_EMAIL_AVAILABLE]: (state, payload) => {
        return Object.assign({}, state, {
            emailCheckSuccessful: true,
            emailAvailableResponse: payload
        });
    },
    [CHECK_EMAIL_AVAILABLE_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            emailCheckSuccessful: false,
            emailAvailableResponse: payload
        });
    }
});
